/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q10Inputs */

const et_faq_q10 = /** @type {(inputs: Faq_Q10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Millised on ScalingWebsi lepingutingimused?`)
};

const en_faq_q10 = /** @type {(inputs: Faq_Q10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are ScalingWebs' contract terms?`)
};

/**
* | output |
* | --- |
* | "What are ScalingWebs' contract terms?" |
*
* @param {Faq_Q10Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q10 = /** @type {((inputs?: Faq_Q10Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q10Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q10(inputs)
	return en_faq_q10(inputs)
});